export const FETCH_DSA_OEM_ADMIN_URL_REQUEST = 'FETCH_DSA_OEM_ADMIN_URL_REQUEST';
export const FETCH_DSA_OEM_ADMIN_URL_SUCCESS = 'FETCH_DSA_OEM_ADMIN_URL_SUCCESS';
export const FETCH_DSA_OEM_ADMIN_URL_FAILURE = 'FETCH_DSA_OEM_ADMIN_URL_FAILURE';

export const DELETE_DSA_OEM_ADMIN_URL_REQUEST = 'DELETE_DSA_OEM_ADMIN_URL_REQUEST';
export const DELETE_DSA_OEM_ADMIN_URL_SUCCESS = 'DELETE_DSA_OEM_ADMIN_URL_SUCCESS';
export const DELETE_DSA_OEM_ADMIN_URL_FAILURE = 'DELETE_DSA_OEM_ADMIN_URL_FAILURE';

export const CHECK_EUROPEAN_COUNTRIES = 'CHECK_EUROPEAN_COUNTRIES';
export const CHECK_TAG_COUNTRIES = 'CHECK_TAG_COUNTRIES';
export const UPDATE_TARGETING_TAGS = 'UPDATE_TARGETING_TAGS';